import { abilitiesPlugin } from "@casl/vue";
import { Ability } from "@casl/ability";
import Vue from "vue";

import { abilityRulesFactory } from "@/compose";

export const ability = new Ability([], {
  subjectName: subject => {
    if (!subject || typeof subject === "string") {
      return subject;
    }

    if (subject._is) {
      return subject._is;
    }

    const Type = typeof subject === "object" ? subject.constructor : subject;

    return Type.modelName || Type.name;
  }
});

abilityRulesFactory.manageAbility(ability);

Vue.use(abilitiesPlugin, ability);
